'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _filterTree = require('./filterTree');

var _filterTree2 = _interopRequireDefault(_filterTree);

var _classificationsHierachy = require('./classifications-hierachy');

var _classificationsHierachy2 = _interopRequireDefault(_classificationsHierachy);

var _lodashMemoize = require('lodash.memoize');

var _lodashMemoize2 = _interopRequireDefault(_lodashMemoize);

var _lookupByIdJs = require('./lookupById.js');

_defaults(exports, _interopExportWildcard(_lookupByIdJs, _defaults));

var ensureIgnore = function ensureIgnore(locale, ignore) {
  return function (_ref) {
    var id = _ref.id;

    return ignore[locale.toUpperCase()].indexOf(id) === -1;
  };
};

var ensureOrder = function ensureOrder(order) {
  return function (a, b, aIndex, bIndex) {

    // index order to be efficient
    var orderIndex = order.reduce(function (memo, id, index) {
      memo[id] = index;
      return memo;
    }, {});

    // if both items are withing the order array sort them
    var aOrderIndex = orderIndex[a.id] || -1;
    var bOrderIndex = orderIndex[b.id] || -1;

    if (aOrderIndex > -1 && bOrderIndex > -1) {
      return aOrderIndex - bOrderIndex;
    }

    // or default sort by original order
    return aIndex - bIndex;
  };
};

var getByLocale = (0, _lodashMemoize2['default'])(function (locale) {
  if (!locale) {
    return _classificationsHierachy2['default'];
  }

  // ids in here are ignored based on locale
  var ignore = {
    AU: [6356, 6357, 6358],
    NZ: [1409, 1410, 1411]
  };

  // ids here if found as children on any node of the tree will be
  // placed in this order. Every node must have a unique ID.
  // This list may become localised in the future if different orders are required
  var order = [1314, 1322, 1378, 1450, 6359, 6360, 1409, 1410, 1411, 6356, 6357, 6358, 6361];

  return (0, _filterTree2['default'])(_classificationsHierachy2['default'], 'subClassifications', ensureIgnore(locale, ignore), ensureOrder(order));
});

exports.getByLocale = getByLocale;
exports['default'] = _classificationsHierachy2['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-classifications-hierarchy/build/index.js
 ** module id = 446
 ** module chunks = 0
 **/